import { render, staticRenderFns } from "./Expectations.vue?vue&type=template&id=05bc7177&scoped=true&"
import script from "./Expectations.vue?vue&type=script&lang=js&"
export * from "./Expectations.vue?vue&type=script&lang=js&"
import style0 from "./Expectations.vue?vue&type=style&index=0&id=05bc7177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bc7177",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
